import _sfc_main from './break-menu.vue2.js';
/* empty css               */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const breakMenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-2b710deb"]]);

export { breakMenu as default };
//# sourceMappingURL=break-menu.js.map
